<template>
  <div>
    <b-form-input
      class="col-1"
      v-model="search"
      placeholder="Введіть ім'я тренера"
    ></b-form-input>
    <b-table :fields="fields" :items="makeTable()" bordered hover>
      <template #cell(Дії)="row">
        <b-button size="sm" @click="showModal(row.item.trainer)" class="mr-1">
          Інформація
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "TrainerTable",
  props: {
    trainers: Object,
  },
  data: function () {
    return {
      fields: ["Ім'я", "Дії"],
      search: null,
      selectedTrainer: null,
    };
  },
  methods: {
    ...mapActions(["setCurrentTrainer"]),
    makeTable() {
      let options = [];
      this.trainers.forEach((trainer) => {
        options.push({
          "Ім'я": trainer.name + " " + trainer.surname,
          trainer: trainer,
        });
      });
      return options;
    },
    showModal(trainer) {
      this.selectedTrainer = trainer;
      this.setCurrentTrainer(trainer);
      this.$root.$emit("bv::show::modal", "modal-trainer-view");
    },
  },
};
</script>

<style scoped></style>
